import React, { useEffect, useState, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { Menu, MenuItem } from 'semantic-ui-react'
import styled from 'styled-components'
import { useTabletAndBelowMediaQuery } from 'layout'
import { useQueryString } from 'hooks'
import { useAuth } from 'context'

import { CompanyMenuPermissionScreen } from './CompanyMenuPermission'
import { UserMenuPermissionScreen } from './UserMenuPermission'

const PermissionSettingContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 20px;
    .permission-menu {
        width: 100% !important;
        overflow-x: auto;
        ::-webkit-scrollbar {
            height: 5px;
        }
        .active {
            background: ${({ theme }) => theme.colors.body} !important;
        }
    }
`

const MenuList = ({ list, activeTab, onTabChange, isMobile }) => (
    <Menu vertical={!isMobile} className="permission-menu">
        {list.map(ele => (
            <MenuItem
                key={ele.key}
                active={activeTab === ele.key}
                onClick={() => onTabChange(ele.key)}
            >
                {ele.title}
            </MenuItem>
        ))}
    </Menu>
)

export const MenuPermissionScreen = () => {
    const isMobile = useTabletAndBelowMediaQuery()
    const navigate = useNavigate()
    const query = useQueryString()
    const { user } = useAuth()
    const isSuperAdmin = user?.IsSuperAdmin
    const permissionTab = query.get('permissionTab')

    const subTabs = useMemo(() => {
        const tabs = []
        if (isSuperAdmin) {
            tabs.push({ key: 'company', title: 'Company Menu Permission' })
        }
        tabs.push({ key: 'user', title: 'User-level Permissions' })
        return tabs
    }, [isSuperAdmin])

    const [activeTab, setActiveTab] = useState(() => {
        if (isSuperAdmin) return 'company'
        return 'user'
    })

    useEffect(() => {
        if (permissionTab && subTabs.some(tab => tab.key === permissionTab)) {
            setActiveTab(permissionTab)
        } else {
            setActiveTab(isSuperAdmin ? 'company' : 'user')
        }
    }, [permissionTab, subTabs, isSuperAdmin])

    const handleTabChange = (key) => {
        navigate(`?permissionTab=${key}`)
    }

    // If there is only one tab available (e.g. not a super admin), render the content directly without the sidebar menu
    if (subTabs.length <= 1) {
        return (
            <div className="col-12 px-0">
                <UserMenuPermissionScreen />
            </div>
        )
    }

    return (
        <PermissionSettingContainer
            className={`col-12 ${isMobile ? 'flex-column' : 'flex-row'
                }`}
        >
            <div className={`${isMobile ? 'col-12' : 'col-3'}`}>
                <MenuList
                    isMobile={isMobile}
                    list={subTabs}
                    activeTab={activeTab}
                    onTabChange={handleTabChange}
                />
            </div>
            <div className="col mt-0 px-0">
                {activeTab === 'company' && <CompanyMenuPermissionScreen />}
                {activeTab === 'user' && <UserMenuPermissionScreen />}
            </div>
        </PermissionSettingContainer>
    )
}
